import React, { Fragment } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import airplane from '../../../static/images/about/animation/air-plane.webp'
import { TitleOne, BorderText, Paragraph } from '../../../components/text'
import { useTranslation } from 'react-i18next'
import ImageDownloadLink from '../../../components/image-download/index'

const AboutLastContentStyle = styled.div`
  display: flex;
  width: 100%;
  margin-top: 70px;
  .image {
    display: block;
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
  .title {
    color: #555555;
    font-family: 'Open Sans';
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
  }
`

export const AboutLastTitle = () => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <TitleOne display="block" align="left">
        {t('pageAbout.part20')}
      </TitleOne>
      <div style={{ marginTop: 20 }}>
        <Paragraph style={{ display: 'block' }}>
          {t('pageAbout.part21')}
        </Paragraph>
      </div>
      <BorderText></BorderText>
    </Fragment>
  )
}

export const AboutLastContent = () => {
  const { t } = useTranslation()
  return (
    <AboutLastContentStyle>
      <Grid>
        <Row between="lg">
          <Col lg={5} md={5} sm={6} xs={12}>
            <div className="image">
              <img src={airplane} alt="" />
            </div>
          </Col>
          <Col lg={5} md={5} sm={6} xs={12}>
            <div className="content">
              <div className="title">{t('pageAbout.part22')}</div>
              <div style={{ marginTop: 20 }}>
                <Paragraph>{t('pageAbout.part23')}</Paragraph>
                <ImageDownloadLink />
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </AboutLastContentStyle>
  )
}
